module.exports = __webpack_public_path__ + "img/image-quote.9eb709f6.svg";